export enum Severity {
  Emergency = 'emergency',
  Urgent = 'urgent',
  Appointment = 'appointment',
  Unknown = 'unknown',
}
